import { CameraType } from '@/features/user-settings';
import { SettingsType } from '@/features/user-settings/hooks/use-settings/use-settings';

// TODO: Find out what's this number is ?
const DEFAULT_IMAGE_AREA = 0.028 * 0.93;

const getImageArea = ({
  camera,
  squareSize,
  camPixelHeight,
  detectedSquareSize,
}: Pick<SettingsType, 'camera' | 'squareSize' | 'detectedSquareSize'> & {
  camPixelHeight: number;
}) => {
  const imageArea =
    camera === CameraType.Lab && detectedSquareSize !== 0
      ? Math.pow(camPixelHeight / 2, 2) *
        Math.PI *
        (squareSize! / Math.pow(detectedSquareSize!, 2))
      : DEFAULT_IMAGE_AREA;

  return imageArea;
};

export const getImageVolume = ({
  camera,
  squareSize,
  chamberHeight,
  camPixelHeight,
  detectedSquareSize,
}: Pick<
  SettingsType,
  'camera' | 'squareSize' | 'chamberHeight' | 'detectedSquareSize'
> & { camPixelHeight: number }) => {
  const volume =
    getImageArea({ camera, squareSize, camPixelHeight, detectedSquareSize }) *
    (chamberHeight! / 1000);
  return volume;
};
